










































import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator';
import RuleSetServices, { RuleSetDto } from '@/services/ruleSet';
import { checkCode } from '@/libs/util';
@Component
export default class RuleSets extends Vue {
  @PropSync('visible', { type: Boolean }) syncVisible!: boolean;
  @Prop() folderId!: number;
  @Prop() ruleSetId!: number;
  ruleSetSrv = new RuleSetServices();
  title: string = '新建决策集';

  @Watch('visible')
  async onVisibleChange() {
    if (this.ruleSetId > 0) {
      this.title = '编辑决策集';
      this.getInfo();
    } else {
      this.formData = {};
      this.title = '新建决策集';
    }
  }

  async getInfo() {
    this.formData = await this.ruleSetSrv.getInfo(this.ruleSetId);
  }

  formData: RuleSetDto = {};
  loading: boolean = false;
  async submit() {
    const must: { field: 'ruleSetCode' | 'ruleSetName'; msessage: string }[] = [
      { field: 'ruleSetCode', msessage: '决策集编码不能为空' },
      { field: 'ruleSetName', msessage: '决策集名称不能为空' }
    ];
    for (let val of must) {
      if (!this.formData[val.field]) {
        this.$message.error(val.msessage);
        return false;
      }
    }
    if (!checkCode(this.formData.ruleSetCode)) {
      this.$message.error('编码只能包含英文字母、数字、下划线');
      return false;
    }
    if (!this.ruleSetId) {
      let code = 'RULE_SET_' + this.formData.ruleSetCode;
      let exist = await this.ruleSetSrv.getList({ ruleSetCode_eq: code });
      if (exist.length > 0) {
        this.$message.error(`编码[${code}]已经存在`);
        return false;
      }
    }
    this.loading = true;
    if (this.ruleSetId > 0) {
      let res = await this.ruleSetSrv.update(this.formData);
      this.formData = {};
      this.$emit('success', res);
    } else {
      let res = await this.ruleSetSrv.add({ ...this.formData, ruleSetCategoryId: this.folderId });
      this.formData = {};
      this.$emit('success', res);
    }
    this.$message.success('操作成功');
    this.syncVisible = false;
    this.loading = false;
  }

  close() {
    this.syncVisible = false;
    this.formData = {};
    this.$emit('success');
  }
}
